// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"9c9a92c8","74":"9ef9db46","496":"7860ef79","634":"459e6c6f"}[chunkId] + ".chunk.js";
};